<script>
import { Pie, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
	name: 'customer-chart',
	extends: Pie,
	mixins: [reactiveProp],
	props: ['chartId', 'options'],
	mounted() {
		if (this.chartId === 'customer') {
			this.renderChart(this.chartData, this.options);
			// this.legendMarkup = this.$data._chart.generateLegend();
		}
	},
};
</script>
